/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал массового оповещения через домофоны
 */

/**
 * Сервис управления массовым оповещением через домофоны
 */
export class BroadcastAlertServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод запуска массового оповещения через домофоны.
   * Метод доступен для: ApiKey
   */
  PostBroadcastAlertStart = (req: PostBroadcastAlertStartRequestDto, init?: RequestInit): Promise<PostBroadcastAlertStartResponseDto> => {
    return fm.request<PostBroadcastAlertStartRequestDto, PostBroadcastAlertStartResponseDto>(`${this.host}/dial/internal/api/v1/broadcast_alert/start`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на запуск массового оповещения через домофоны
 */
export type PostBroadcastAlertStartRequestDto = {
  /**
   * Вызываемый номер.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  toNumber: string
  /**
   * Вызывающий номер.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  fromNumber: string
}
/**
 * Ответ на запрос на запуск массового оповещения через домофоны
 */
export type PostBroadcastAlertStartResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostBroadcastAlertStartResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostBroadcastAlertStartResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Звуковой файл не найден
   */
  readonly scenarioNotFound: PostBroadcastAlertStartResponseErrorScenarioNotFoundRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostBroadcastAlertStartResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Звуковой файл не найден
   */
  readonly scenarioNotFound: PostBroadcastAlertStartResponseErrorScenarioNotFoundDto
}>
/**
 * Не найден сценарий оповещения
 */
export type PostBroadcastAlertStartResponseErrorScenarioNotFoundRequestDto = {
}
/**
 * Не найден сценарий оповещения
 */
export type PostBroadcastAlertStartResponseErrorScenarioNotFoundDto = {
}
/**
 * Ошибки валидации
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на запуск массового оповещения через домофоны
   */
  "PostBroadcastAlertStartRequest": {
    "kind": "class",
    "text": "Запрос на запуск массового оповещения через домофоны",
    "fields": {
      /**
       * Вызываемый номер.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "toNumber": {
        "type": "string",
        "text": "Вызываемый номер.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
      /**
       * Вызывающий номер.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "fromNumber": {
        "type": "string",
        "text": "Вызывающий номер.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
    },
  },
  /**
   * Ответ на запрос на запуск массового оповещения через домофоны
   */
  "PostBroadcastAlertStartResponse": {
    "kind": "class",
    "text": "Ответ на запрос на запуск массового оповещения через домофоны",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostBroadcastAlertStartResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostBroadcastAlertStartResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Звуковой файл не найден
       */
      "scenarioNotFound": {
        "type": "PostBroadcastAlertStartResponse.Error.ScenarioNotFound",
        "text": "Звуковой файл не найден",
      },
    },
  },
  /**
   * Не найден сценарий оповещения
   */
  "PostBroadcastAlertStartResponse.Error.ScenarioNotFound": {
    "kind": "class",
    "text": "Не найден сценарий оповещения",
  },
  /**
   * Ошибки валидации
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}